import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

// Fetch the initial language from localStorage or use the fallback
const initialLanguage = localStorage.getItem("language") || "en";

// `.use` here is the default-export instance method, not the named `use` from i18next.
/* eslint-disable import/no-named-as-default-member */
i18n
  .use(HttpBackend) // Load translations from the backend
  .use(LanguageDetector) // Automatically detect user language
  .use(initReactI18next) // Initialize react-i18next
  .init({
    fallbackLng: "en", // Default language
    // Only load common namespace at startup; others load on demand
    // via useTranslation(["application", "report"]) in components
    ns: ["common"],
    defaultNS: "common",
    partialBundledLanguages: true,
    lng: initialLanguage, // Set the initial language
    debug: false, // Enable for debugging,
    backend: {
      // Adjust the path to accommodate subfolders
      loadPath: "/locales/{{lng}}/{{ns}}.json", // {{ns}} represents namespace (file name)
    },
    detection: {
      // Override LanguageDetector's options
      order: ["localStorage", "navigator"], // Check localStorage first, then browser settings
      caches: ["localStorage"], // Store the detected language in localStorage
    },
    interpolation: {
      escapeValue: false, // React already escapes HTML by default
    },
  });

export default i18n;
